export default __webpack_public_path__ + "img/no-floor-plan.svg";